import { GatewayQuestionnaire } from "@conformite/gateway";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { controleQuinquennalKeys } from "@src/data/controle-quinquennal/hook/controle-quinquennal.keys";
import { QuestionnaireApi } from "../questionnaire.api";
import { questionnaireKeys } from "./questionnaire.keys";

export const useSaveQuestionnaireInstanceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: GatewayQuestionnaire.SaveQuestionnaireInstanceRequestType
    ) => QuestionnaireApi.saveInstance(body),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: questionnaireKeys.instances(
          variables.contextType,
          variables.contextId
        ),
      });
      await queryClient.invalidateQueries({
        queryKey: questionnaireKeys.latestInstance(
          variables.contextType,
          variables.contextId
        ),
      });
      // Les réponses alimentent l'avancée du traitement de la liste des CQ.
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.lists(),
      });
    },
  });
};
